import { createFileRoute } from '@tanstack/react-router';
import { PageHero } from '@/components/layout/PageHero';
import { useMe } from '@/features/auth/hooks';
import { NotificationsSection } from '@/features/profile/components/NotificationsSection';
import { ProfileHeader } from '@/features/profile/components/ProfileHeader';
import { ProfileSection } from '@/features/profile/components/ProfileSection';
import { SecuritySection } from '@/features/profile/components/SecuritySection';

export const Route = createFileRoute('/profile')({
  component: ProfilePage,
});

function ProfilePage() {
  const me = useMe();
  return (
    <>
      <PageHero
        title="Profile & Settings"
        subtitle="Manage your personal details, notifications and account security."
      />
      <main className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-10 pt-8 pb-20">
        {/* Content spans the full page width to match the PageHero above. */}
        <div className="space-y-6">
          <ProfileHeader user={me.data} />
          <div className="grid gap-6 md:grid-cols-2">
            <ProfileSection />
            <div className="flex flex-col gap-6 [&>:last-child]:flex-1">
              <NotificationsSection />
              <SecuritySection />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
